type WithPrefix<T, P extends string> = {
  [K in keyof T as `${P}${string}`]: T[K]
}

const merge = <T extends object, TT extends object>(dict1: T, dict2: TT): T & TT => {
  const mergedDict = {} as T & TT

  for (const key in dict1) {
    if (typeof dict1[key] === 'object' && typeof dict2[key as string] === 'object') {
      mergedDict[key] = merge(dict1[key as string], dict2[key as string])
    } else {
      mergedDict[key as string] = dict1[key]
    }
  }

  for (const key in dict2) {
    if (!(key in dict1)) {
      mergedDict[key as string] = dict2[key]
    }
  }

  return mergedDict
}

export const Dicts = {
  addPrefixToKeys: <T extends object, P extends string>(obj: T, prefix: P): WithPrefix<T, P> => {
    return Object.keys(obj).reduce(
      (acc, key) => {
        ;(acc as any)[`${prefix}${key}`] = obj[key as keyof T]
        return acc
      },
      {} as WithPrefix<T, P>
    )
  },

  merge
}
